"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Boards = void 0;
const errors_1 = require("@air/errors");
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const request_1 = require("./request");
const util_1 = require("./util");
const baseListOptions = {
    isMemberOfBoard: 'ALL',
    numThumbnails: 1,
};
const defaultListOptions = Object.assign(Object.assign({}, baseListOptions), { limit: 100, view: 'all' });
const defaultGetOptions = {
    numThumbnails: 1,
    includeAncestors: false,
};
const getBoardsGetOptions = (options = {}) => (Object.assign(Object.assign({}, defaultGetOptions), options));
/**
 * Determines if the authenticated user follows the specified board.
 */
function follows(_a) {
    return __awaiter(this, arguments, void 0, function* ({ boardId, workspaceId, }) {
        try {
            yield (0, request_1.airRequest)(types_1.EndpointType.boards, {
                method: 'GET',
                endpoint: `${boardId}/followers/me`,
                boardContext: boardId,
                workspaceId,
            });
            return true;
        }
        catch (err) {
            if (err instanceof errors_1.Airror && err.type === errors_1.NOT_FOUND.type) {
                return false;
            }
            throw err;
        }
    });
}
/**
 * Causes the authenticated user to follow the specified board.
 */
function follow(_a) {
    return __awaiter(this, arguments, void 0, function* ({ boardId, workspaceId, }) {
        yield (0, request_1.airRequest)(types_1.EndpointType.boards, {
            method: 'PUT',
            endpoint: `${boardId}/followers/me`,
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * Unfollow one or more boards as an authenticated user
 */
function unfollow(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardIds, }) {
        yield (0, request_1.airRequest)(types_1.EndpointType.boards, {
            method: 'DELETE',
            endpoint: `followers/me`,
            workspaceId,
            body: { boardIds },
        });
    });
}
/**
 * Gets a board by id with the same query params as list
 */
function get(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId, boardId } = _a, rest = __rest(_a, ["workspaceId", "boardId"]);
        const params = getBoardsGetOptions(rest);
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `${boardId}?${(0, querystring_1.stringify)(params)}`,
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * Gets a board by id with the same query params as list without needing a workspaceId
 */
function getWithNoWorkspaceId(_a) {
    var { boardId } = _a, rest = __rest(_a, ["boardId"]);
    const defaultOptions = {
        includeAncestors: true,
        numThumbnails: 1,
    };
    return (0, request_1.airRequest)(types_1.EndpointType.boards, {
        endpoint: `${boardId}?${(0, querystring_1.stringify)(Object.assign(Object.assign({}, defaultOptions), rest))}`,
        boardContext: boardId,
    });
}
/**
 * Gets a boards statistics including total asset/file/subboard count and physical size
 * @param boardId id of board to get
 * @param options
 *   includeDescendants - include all children in totals
 *   onlyCoverVersions - only get total size of current cover asset versions (clips)
 */
function getBoardStats(_a) {
    var { workspaceId, boardId } = _a, rest = __rest(_a, ["workspaceId", "boardId"]);
    const { includeDescendants = false, onlyCoverVersions = false } = rest || {};
    return (0, request_1.airRequest)(types_1.EndpointType.boards, {
        endpoint: `${boardId}/stats?${(0, querystring_1.stringify)({
            includeDescendants,
            onlyCoverVersions,
        })}`,
        workspaceId,
        boardContext: boardId,
    });
}
/**
 * Gets a representation of a board used to determine the users default starting point in a workspace
 * Either returns the user's most recently viewed board or the highest positioned root level board.
 * If those don't exist this will 404
 */
function getDefaultBoard({ workspaceId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.boards, {
        endpoint: `default`,
        workspaceId,
    });
}
function list(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        const withDefaults = Object.assign(Object.assign({}, defaultListOptions), rest);
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `list`,
            method: 'POST',
            body: withDefaults,
            workspaceId,
        });
    });
}
/**
 * API to bulk fetch board details by provided boardIds
 */
function listByIds(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'listByIds',
            method: 'POST',
            workspaceId,
            body: rest,
        });
    });
}
function listChanged(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `changed?${(0, util_1.formatParamsForHttp)(rest)}`,
            method: 'GET',
            workspaceId,
        });
    });
}
/**
 * Creates a board, with the title and description that are passed, as well as clips
 * @param workspaceId the workspace id
 * @param board New board object containing title and description and optionally include parentId and thumbnail
 * @param clipIds Ids of clips to add to this board
 * @param shouldFollow whether the specified members of this board should follow the board
 */
function create(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, board, clipIds, shouldFollow = false, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            method: 'POST',
            body: { board, clipIds, shouldFollow },
            workspaceId,
            boardContext: board.parentId,
        });
    });
}
/**
 * Updates a board (based on the ID passed) with the corresponding properties
 * @param workspaceId the workspace id
 * @param id Id of board to update
 * @param props Updated title and/or description
 */
function update(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, id, props, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'update',
            method: 'POST',
            body: Object.assign({ id }, props),
            workspaceId,
            boardContext: id,
        });
    });
}
function updateThumbnail({ workspaceId, boardId, clipId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.boards, {
        method: 'PATCH',
        endpoint: `${boardId}/thumbnailSource`,
        body: {
            clipId,
        },
        workspaceId,
        boardContext: boardId,
    });
}
/**
 * Add accounts' favoriting of a board
 * @param workspaceId the workspace id
 * @param boardId Id of board to add members to
 * @param accountIds Ids of members to add
 */
function addMembers(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, accountIds, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `${boardId}/addMembers`,
            method: 'POST',
            body: { accountIds },
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * Removes accounts' favoriting of a board
 * @param workspaceId the workspace id
 * @param boardId Id of board to add members to
 * @param accountIds Ids of members to add
 */
function removeMembers(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, accountIds, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `${boardId}/removeMembers`,
            method: 'POST',
            body: { accountIds },
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * List board guests (based on the ID given) from the remote database
 * @param workspaceId the workspace id
 * @param boardId Id of board to add members to
 */
function listGuests(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            method: 'GET',
            endpoint: `${boardId}/guests`,
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * Remove board guests (based on the ID given) from the remote database
 * Pass list options to also get back the board
 * @param workspaceId the workspace id
 * @param boardId Id of board to add members to
 * @param guests Array of guests (by accountId) or pending guests (by email) to remove
 */
function removeGuests(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, guests, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            method: 'DELETE',
            endpoint: `${boardId}/guests`,
            body: guests,
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * Remove board guests (based on the ID given) from the remote database
 * Pass list options to also get back the board
 * @param workspaceId the workspace id
 * @param boardId Id of board to add members to
 * @param guests Array of guests or pending guests to remove
 */
function updateGuests(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, guests, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            method: 'PATCH',
            endpoint: `${boardId}/guests`,
            body: guests,
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * Deletes boards using boardIds and their descendant clips that don't exist under other boards
 * @param workspaceId the workspace id
 * @param boardIds Ids of boards to delete
 */
function batchDeleteBoards(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardIds, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'batch',
            body: { boardIds },
            method: 'DELETE',
            workspaceId,
            boardContext: boardIds,
        });
    });
}
/**
 * Moves boards using boardIds under a new parent with id newParentId
 * @param workspaceId the workspace id
 * @param boardIds Ids of boards to move
 * @param newParentId Id of parent to move boards under
 * @param [libraryId] Id of library to move boards into
 *                    This parameter is really only required when newParentId is null (moving to the top-level),
 *                    since there would be no wait to get library context since there is no target newParentId.
 *                    If both newParentId and libraryId are specified, newParentId must be in the libraryId.
 * @returns BatchMoveBoardsResponse
 */
function batchMoveBoards(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardIds, newParentId, libraryId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `move/batch`,
            method: 'POST',
            body: {
                boardIds,
                newParentId,
                libraryId,
            },
            workspaceId,
            boardContext: [...boardIds, ...(newParentId ? [newParentId] : [])],
        });
    });
}
/**
 * Add clips to board by boardId and clipIds
 * @param workspaceId the workspace id
 * @param boardId Id of board to add clips to
 * @param boardIds Array of board Ids to add clips to
 * @param clipIds Ids of clips to add
 */
function addClips(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardIds, clipIds, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'clips/batch',
            method: 'POST',
            body: { clipIds, boardIds },
            workspaceId,
            boardContext: boardIds,
        });
    });
}
/**
 * Removes clips from board by boardId and ClipIds
 * @param workspaceId the workspace id
 * @param boardId Id of board to remove clip from
 * @param clipIds Ids of clips to remove from board
 * @param recursive whether to remove recursively down the board children
 */
function removeClips(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, clipIds, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'clips/batch',
            method: 'DELETE',
            body: {
                boardId,
                clipIds,
            },
            workspaceId,
            boardContext: boardId,
        });
    });
}
function viewBoard(_a) {
    return __awaiter(this, arguments, void 0, function* ({ boardId }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'view',
            method: 'POST',
            body: { boardId },
            boardContext: boardId,
        });
    });
}
/**
 * Move board(s) between 2 other boards or before/after a board
 * @param workspaceId the workspace
 * @param idsToMove Board ids to move (in the order that they appear in gallery)
 * @param betweenIds
 *          moveBeforeId Board id to move idsToMove before (end)
 *          moveAfterId Board id to move idsToMove after (start)
 * @param parentBoardId the parent board id
 * @param cursor If moving board to end of page, optional cursor can be supplied to infer betweenIds.moveBeforeId
 */
function updateBoardPositions(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, idsToMove, betweenIds, parentBoardId, cursor, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'position',
            method: 'PATCH',
            body: {
                idsToMove,
                betweenIds,
                cursor,
            },
            workspaceId,
            boardContext: parentBoardId,
        });
    });
}
/**
 * Move board clip(s) between 2 other board clips or before/after a board clip
 * @param workspaceId the workspace
 * @param boardClipsToMove Board clips to move (in the order that they appear in gallery)
 * @param betweenBoardClips
 *          moveBeforeBoardClip Same as moveBeforeId except is board clip
 *          moveAfterId Same as moveAfterId except is boardClip
 * @param parentId the parent board id
 * @param cursor If moving clip to end of page, optional cursor can be supplied to infer betweenBoardClips.moveBeforeId
 */
function updateBoardClipPositions(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardClipsToMove, betweenBoardClips, parentBoardId, cursor, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: 'clips/position',
            method: 'PATCH',
            body: {
                boardClipsToMove,
                betweenBoardClips,
                cursor,
            },
            workspaceId,
            boardContext: parentBoardId,
        });
    });
}
function updatePersonalBoardPositions({ workspaceId, idsToMove, betweenIds, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.boards, {
        endpoint: 'members/position',
        method: 'PATCH',
        body: {
            idsToMove,
            betweenIds,
        },
        workspaceId,
    });
}
function updateBoardView(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId, boardId } = _a, rest = __rest(_a, ["workspaceId", "boardId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `${boardId}/views/${rest.id}`,
            method: 'PATCH',
            body: rest,
            workspaceId,
            boardContext: boardId,
        });
    });
}
/**
 * Returns custom fields on a given board
 */
function listCustomFields(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, boardId, options = {}, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `${boardId}/customfields?${(0, util_1.formatParamsForHttp)(options)}`,
            workspaceId,
        });
    });
}
/**
 * Sets board-level custom field values, supports batch updating as well
 */
function setCustomFieldValue(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, customFieldId, boardIds, valueId, plainTextValue, dateValue, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `customfields/${customFieldId}`,
            method: 'PUT',
            workspaceId,
            body: {
                boardIds,
                valueId,
                plainTextValue,
                dateValue,
            },
            boardContext: boardIds,
        });
    });
}
/**
 * Sets board-level custom field values for multi-select custom fields
 */
function setCustomFieldValues(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, customFieldId, boardIds, valueIdsToAdd, valueIdsToRemove, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `customfields/${customFieldId}`,
            method: 'PUT',
            workspaceId,
            body: {
                boardIds,
                valueIdsToAdd,
                valueIdsToRemove,
            },
            boardContext: boardIds,
        });
    });
}
/**
 * This function takes a boardId and returns an object telling you if that board is in a workspace that has SAML-enforced
 */
function getWorkspaceSAMLEnforcedByBoardId(_a) {
    return __awaiter(this, arguments, void 0, function* ({ boardId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            method: 'GET',
            endpoint: `${boardId}/workspaceSamlEnforced`,
            authorized: false,
        });
    });
}
/**
 * API to query for simplified Board information for two-way sync clients.
 */
function listForSync(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.boards, {
            endpoint: `listForSync?${(0, util_1.formatParamsForHttp)(rest)}`,
            workspaceId,
        });
    });
}
exports.Boards = {
    follows,
    follow,
    unfollow,
    get,
    list,
    listByIds,
    listChanged,
    listForSync,
    create,
    update,
    addMembers,
    removeMembers,
    listGuests,
    removeGuests,
    updateGuests,
    batchDeleteBoards,
    batchMoveBoards,
    addClips,
    removeClips,
    viewBoard,
    updateBoardPositions,
    updateBoardClipPositions,
    updateBoardView,
    listCustomFields,
    setCustomFieldValue,
    setCustomFieldValues,
    getWithNoWorkspaceId,
    getBoardStats,
    getDefaultBoard,
    updateThumbnail,
    updatePersonalBoardPositions,
    getWorkspaceSAMLEnforcedByBoardId,
};
//# sourceMappingURL=boards.js.map